/**
 * @file edit-products.tsx
 * @module app/modules/uProcure/products/edit-master-product/edit-products
 * @description Implements the edit products interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from "react";
import General from "./general";
import PriceDimesions from "./price-dimensions";
import TechnicalDetails from "./technical-details";
import ProductImages from "./product-images";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { success } from "../../../../../Global/toast";
import { catalogue } from "../../../../../utils/toast";
import ProductAddedSuccessfully from "../../../../modals/ProductAddedSuccessfully";
import ProductGuidelines from "../../../../modals/ProductGuidelines";
import clsx from "clsx";
import APICallService from "../../../../../api/apiCallService";
import { product } from "../../../../../api/apiEndPoints";
import { productJSON } from "../../../../../api/apiJSON/product";
import Loader from "../../../../../Global/loader";
import {
  All_Products,
  CartonWithDozens,
  CartonWithPieces,
  DateSelection,
  Dozen,
  MasterProduct,
  MultiLineText,
  MultiSelection,
  Piece,
  SingleLineText,
  SingleSelection,
} from "../../../../../utils/constants";
import { fileValidation } from "../../../../../Global/fileValidation";
import RemoveVariants from "../../../../modals/remove-variants";
import Notification from "../../../../notification/notification";
// import { getKey } from "../../../../Global/history";
// import { warehouse as warehouseStoreString } from "../../../../utils/storeString";
import Method from "../../../../../utils/methods";
import { useAuth } from "../../../auth";
import { useWarehouse } from "../../../../context/WarehouseContext";

const EditProduct = () => {
  const {currentUser} = useAuth();

  const { selectedWarehouse } = useWarehouse();
  const { state }: any = useLocation();
  const [sortClass, setSortClass] = useState({
    name: 1,
    position: 1,
  });
  const [isChanged, setIsChanged] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [categories, setCategories] = useState<any>();
  const [variants, setVariants] = useState<any>();
  const [countries, setCountries] = useState<any>();
  const [brands, setBrands] = useState<any>();
  const [technicalFields, setTechnicalFields] = useState<any>();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showVariantModal, setShowVariantModal] = useState(false);
  const [initCombinations, setInitCombinations] = useState(false);
  const [removedTechnicalDetails, setRemovedTechnicalDetails] = useState([]);
  const [initialProductData, setInitialProductData] = useState<any>({
    primaryCategory: false,
    subCategory: false,
    groupCategory: false,
    productTitle: false,
    country: false,
    brand: false,
    description: false,
    variants: false,
    noneSelected: false,
    productName: false,
    isDraft: false,
    minimumCombinations: false,
    selectedVariants: [],
    combinations: [
      {
        title: false,
        validation: false,
        dimensions: {
          cartoonDozens: false,
          piecesDozens: false,
          cartoonPieces: false,
          cartoonPrice: false,
          cartoonDiscount: false,
          cartoonDiscountPrice: false,
          cartoonDimenisionL: false,
          cartoonDimenisionW: false,
          cartoonDimenisionH: false,
          cartoonWeight: false,
          cartoonQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          dozenPrice: false,
          dozenDiscount: false,
          dozenDiscountPrice: false,
          dozenDimenisionL: false,
          dozenDimenisionW: false,
          dozenDimenisionH: false,
          dozenWeight: false,
          dozenQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          piecePrice: false,
          pieceDiscount: false,
          pieceDiscountPrice: false,
          pieceDimenisionL: false,
          pieceDimenisionW: false,
          pieceDimenisionH: false,
          pieceWeight: false,
          pieceQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
        },
      },
    ],
  });
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      let params: any = {
        product: state._id,
      };
      if (selectedWarehouse?.value) {
        params.warehouse = selectedWarehouse?.value;
      }
      let apiService = new APICallService(
        product.initProduct,
        params,
        "",
        "",
        "",
        "",
        MasterProduct,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();
      let temp = { ...generalData };
      let tempValidation = { ...generalDataValidation };
      if (response.defaultItems) {
        let catTemp: any = [];
        let filterTechnical: any = [];
        let filterTechnicalValidation: any = [];
        response.defaultItems.technicalFields.map((techVal: any) => {
          if (techVal.category === response.product.category.reference) {
            let temp: any = [];
            if (techVal.options.length) {
              techVal.options.map((optionsVal: any) => {
                temp.push({
                  ...optionsVal,
                  value: optionsVal.title,
                  label: optionsVal.title,
                });
              });
            }
            filterTechnical.push({ ...techVal, options: temp });
            filterTechnicalValidation.push({ valid: false });
          }
        });
        if (filterTechnical.length) {
          temp.defaultTechnicalFields = filterTechnical;
        }
        tempValidation.defaultTechnicalFields = filterTechnicalValidation;
        const newArr: any = [];
        if (temp.defaultTechnicalFields) {
          temp.defaultTechnicalFields.forEach((o: any) => {
            const matchingInfo = response.product.technicalInfo.find(
              ({ reference }: any) => {
                return o._id === reference;
              }
            );
            if (matchingInfo && o.enabled) {
              const optionRef: any = [];
              if (matchingInfo.options.length) {
                matchingInfo.options.map((val: any) => {
                  optionRef.push(val._id);
                });
              }
              newArr.push({
                selectedOptions: optionRef,
                answer: matchingInfo.answer || "",
                ...o,
              });
            } else {
              const applicableField =
                response.defaultItems.technicalFields.find(
                  ({ _id }: any) => o._id === _id
                );
              if (applicableField) {
                let temp: any = [];
                applicableField.options.map((val: any) => {
                  temp.push({
                    label: val.title,
                    title: val.title,
                    value: val.title,
                    _id: val._id,
                  });
                });
                applicableField.options = temp;
                newArr.push({
                  selectedOptions: [],
                  answer: "",
                  ...applicableField,
                });
              }
            }
          });
          // temp.defaultTechnicalFields.forEach((o: any) => {
          //   const matchingInfo: any = response.product.technicalInfo.find(
          //     ({ reference }: any) => {
          //       return o._id === reference;
          //     }
          //   );
          //   console.log(matchingInfo);
          //   if (!matchingInfo) {
          //     let temp: any = [...removedTechnicalDetails];
          //     temp.push(o.name);
          //     setRemovedTechnicalDetails(temp);
          //   }
          // });
          // response.product.technicalInfo.forEach((o: any) => {
          //   if (o.enabled === false) {
          //     // This technical detail has been detached
          //     let temp: any = [...removedTechnicalDetails];
          //     temp.push(o.name);
          //     setRemovedTechnicalDetails(temp);
          //   }
          // });
          const removedTechnicalDetails = response.product.technicalInfo
            .filter((o: any) => o.enabled === false)
            .map((o: any) => o.name);
          setRemovedTechnicalDetails(removedTechnicalDetails);
        }
        let defaultSubCategory: any = [];
        response.defaultItems.categories.map((catVal: any) => {
          if (catVal._id === response.product.category.reference) {
            defaultSubCategory = catVal.categories;
          }
        });
        let defaultGroupCategory: any = [];
        defaultSubCategory.map((catVal: any) => {
          if (catVal._id === response.product.subCategory.reference) {
            defaultGroupCategory = catVal.categories;
          }
        });
        temp.primaryCategory = response.product.category.reference;
        temp.searchTag = {
          inputValue: '',
          options: response?.product?.searchTag
            ? response?.product?.searchTag.map((item: any) => {
              return {
                value: item,
                label: item,
                title: item,
              };
            })
            : [],
        };

        tempValidation.primaryCategory = false;
        temp.subCategory = response.product.subCategory.reference;
        tempValidation.subCategory = false;
        temp.defaultSubCategory = defaultSubCategory;
        temp.defaultGroupCategory = defaultGroupCategory;
        temp.groupCategory = response.product.groupCategory
          ? response.product.groupCategory.reference
          : "";
        temp.taxFree = response.product.taxFree;
        temp.productTax = response.product.productTax;
        tempValidation.groupCategory = false;
        temp.productTitle = response.product.title;
        tempValidation.productTitle = false;
        temp.country = response.product.country
          ? response.product.country.reference
          : "";
        tempValidation.country = false;
        temp.brand = response.product.brand
          ? response.product.brand.reference
          : "";
        tempValidation.brand = false;
        temp.description = response.product.description
          ? response.product.description
          : "";
        tempValidation.description = false;
        temp.variants = [];
        temp.noneSelected = false;
        tempValidation.noneSelected = false;
        tempValidation.minimumCombinations = false;
        temp.clonedRef = response.product._id;
        let tempCombinations: any = [];
        let tempCombinationValidation: any = [];
        let variantsUsingSeparateInfo = response.product["variants"].filter(
          (a: any) => a.variant.techInfoSeparated
        );
        temp.variantsUsingSeparateInfo = variantsUsingSeparateInfo;
        temp.overrideVariantsTechnicalInfo =
          variantsUsingSeparateInfo.length > 0 ? false : true;
        if (response.product["variants"][0]) {
          if (
            !response.product["variants"][0]["variant"]["variantType"].length
          ) {
            temp.noneSelected = true;
          } else {
            let tempVariants: any = [];
            response.product["definedVariantsTypes"].map((selectVal: any) => {
              let options: any = [];
              selectVal.options.map((optionVal: any, index: number) => {
                options.push({ title: optionVal, _id: index });
              });
              response.defaultItems.variants.map((variant: any) => {
                if (selectVal.reference == variant._id) {
                  let catTemp: any = [];
                  variant.categories.map((cat: any) => {
                    if (
                      cat.category === response.product.category.reference &&
                      cat.subCategory === response.product.subCategory.reference
                    ) {
                      catTemp.push({
                        ...cat,
                        options: [...options],
                      });
                    }
                  });
                  if (catTemp.length) {
                    tempVariants.push({
                      ...variant,
                      isSelected: true,
                      _id: selectVal.reference,
                      categories: catTemp,
                    });
                  } else {
                    tempVariants.push({
                      ...variant,
                      isSelected: true,
                      _id: selectVal.reference,
                    });
                  }
                }
              });
            });
            if (tempVariants.length) {
              let variantTemp: any = [];
              tempVariants.map(() => {
                tempValidation.selectedVariants.push(false);
                variantTemp.push(false);
              });
              tempValidation.variants = false;
            }
            temp.variants = tempVariants;
          }
        }
        if (newArr.length) {
          let defaultTemp: any = [];
          newArr.map(() => {
            defaultTemp.push({ valid: false });
          });
          tempValidation.defaultTechnicalFields = defaultTemp;
        }
        temp.defaultTechnicalFields = newArr;
        if (response.product["variants"].length) {
          response.product["variants"].map(
            (variantVal: any, variantIndex: number) => {
              let key = "";
              let option = "";
              variantVal.variant.variantType.forEach(
                (val: any, index: number) => {
                  option += val.option;
                  key += val.reference;
                  if (index < variantVal.variant.variantType.length - 1) {
                    key += "-"; // Add underscore for key
                    option += ","; // Add comma for option
                  }
                }
              );
              let combinationTemp: any = {
                _id: variantVal.variant._id,
                combinationKey: option + "_" + key,
              };
              let combinationValidationTemp: any = {
                title: false,
                dimensions: {
                  cartoonDozens: false,
                  piecesDozens: false,
                  cartoonPieces: false,
                  cartoonPrice: false,
                  cartoonDiscount: false,
                  cartoonDiscountPrice: false,
                  cartoonDimenisionL: false,
                  cartoonDimenisionW: false,
                  cartoonDimenisionH: false,
                  cartoonWeight: false,
                  cartoonQuantities: [
                    {
                      min: false,
                      max: false,
                      discount: false,
                    },
                  ],
                  dozenPrice: false,
                  dozenDiscount: false,
                  dozenDiscountPrice: false,
                  dozenDimenisionL: false,
                  dozenDimenisionW: false,
                  dozenDimenisionH: false,
                  dozenWeight: false,
                  dozenQuantities: [
                    {
                      min: false,
                      max: false,
                      discount: false,
                    },
                  ],
                  piecePrice: false,
                  pieceDiscount: false,
                  pieceDiscountPrice: false,
                  pieceDimenisionL: false,
                  pieceDimenisionW: false,
                  pieceDimenisionH: false,
                  pieceWeight: false,
                  pieceQuantities: [
                    {
                      min: false,
                      max: false,
                      discount: false,
                    },
                  ],
                },
                validation: false,
              };
              let imagesTemp: any = [];
              variantVal.variant.media.map((val: any, index: number) => {
                imagesTemp.push({ ...val, id: index, order: index });
              });
              combinationTemp = {
                ...combinationTemp,
                title: variantVal.variant.title,
                inventoryInfo: variantVal.variant.inventoryInfo,
                dimensions: {
                  cartoonDozens: variantVal.variant.dozensInCarton,
                  piecesDozens: variantVal.variant.piecesInDozen,
                  cartoonPieces: variantVal.variant.piecesInCarton
                    ? variantVal.variant.piecesInCarton
                    : "0",
                  product: [
                    {
                      id: CartonWithDozens,
                      value: "Carton (Dozens inside)",
                      isChecked: false,
                      isDisabled: false,
                    },
                    {
                      id: CartonWithPieces,
                      value: "Carton (Pieces inside)",
                      isChecked: false,
                      isDisabled: false,
                    },
                    {
                      id: Dozen,
                      value: "Dozen (Pieces inside)",
                      isChecked: false,
                      isDisabled: false,
                    },
                    {
                      id: Piece,
                      value: "Pieces",
                      isChecked: false,
                      isDisabled: false,
                    },
                  ],
                  images: imagesTemp,
                },
              };
              let productTemp: any = [...combinationTemp.dimensions.product];
              let cartoonFound = false;
              let pieceFound = false;
              let dozenFound = false;
              variantVal.variant.quantityTypes.map(
                (quantVal: any, index: number) => {
                  if (
                    quantVal.type === CartonWithDozens ||
                    quantVal.type === CartonWithPieces
                  ) {
                    productTemp[0].isChecked =
                      quantVal.type === CartonWithDozens;
                    productTemp[1].isChecked =
                      quantVal.type === CartonWithPieces;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        cartoonDimenisionH: quantVal.dimensions.height,
                        cartoonDimenisionL: quantVal.dimensions.length,
                        cartoonDimenisionW: quantVal.dimensions.width,
                        cartoonWeight: quantVal.dimensions.weight,
                        cartoonPrice: quantVal.amount,
                        cartoonDiscountPrice: quantVal.discountAmt,
                        cartoonDiscount: "0",
                      },
                    };
                    if (quantVal.discountAmtEnabled) {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          cartoonDiscount: "0",
                        },
                      };
                    }
                    if (quantVal.discountsByQuantities.length) {
                      let discount: any = [];
                      quantVal.discountsByQuantities.map((discVal: any) => {
                        discount.push({
                          min: discVal.min,
                          max: discVal.max,
                          discount: discVal.discountAmt,
                        });
                      });
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          cartoonQuantities: discount,
                          cartoonDiscount: "1",
                        },
                      };
                    } else {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          cartoonQuantities: [
                            {
                              min: 1,
                              max: 5,
                              discount: null,
                            },
                          ],
                        },
                      };
                    }
                    cartoonFound = true;
                  }
                  if (quantVal.type === Piece) {
                    productTemp[3].isChecked = true;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        pieceDimenisionH: quantVal.dimensions.height,
                        pieceDimenisionL: quantVal.dimensions.length,
                        pieceDimenisionW: quantVal.dimensions.width,
                        pieceWeight: quantVal.dimensions.weight,
                        piecePrice: quantVal.amount,
                        pieceDiscountPrice: quantVal.discountAmt,
                        pieceDiscount: "0",
                      },
                    };
                    if (quantVal.discountAmtEnabled) {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          pieceDiscount: "0",
                        },
                      };
                    }
                    if (quantVal.discountsByQuantities.length) {
                      let discount: any = [];
                      quantVal.discountsByQuantities.map((discVal: any) => {
                        discount.push({
                          min: discVal.min,
                          max: discVal.max,
                          discount: discVal.discountAmt,
                        });
                      });
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          pieceQuantities: discount,
                          pieceDiscount: "1",
                        },
                      };
                    } else {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          pieceQuantities: [
                            {
                              min: 1,
                              max: 5,
                              discount: null,
                            },
                          ],
                        },
                      };
                    }
                    pieceFound = true;
                  }
                  if (quantVal.type === Dozen) {
                    productTemp[2].isChecked = true;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        dozenDimenisionH: quantVal.dimensions.height,
                        dozenDimenisionL: quantVal.dimensions.length,
                        dozenDimenisionW: quantVal.dimensions.width,
                        dozenWeight: quantVal.dimensions.weight,
                        dozenPrice: quantVal.amount,
                        dozenDiscountPrice: quantVal.discountAmt,
                        dozenDiscount: "0",
                      },
                    };
                    if (quantVal.discountAmtEnabled) {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          dozenDiscount: "0",
                        },
                      };
                    }
                    if (quantVal.discountsByQuantities.length) {
                      let discount: any = [];
                      quantVal.discountsByQuantities.map((discVal: any) => {
                        discount.push({
                          min: discVal.min,
                          max: discVal.max,
                          discount: discVal.discountAmt,
                        });
                      });
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          dozenQuantities: discount,
                          dozenDiscount: "1",
                        },
                      };
                    } else {
                      combinationTemp = {
                        ...combinationTemp,
                        dimensions: {
                          ...combinationTemp.dimensions,
                          dozenQuantities: [
                            {
                              min: 1,
                              max: 5,
                              discount: null,
                            },
                          ],
                        },
                      };
                    }
                    dozenFound = true;
                  }
                  // Reset values for types that are not encountered
                  if (!cartoonFound) {
                    productTemp[0].isChecked = false;
                    productTemp[1].isChecked = false;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        cartoonDimenisionH: "",
                        cartoonDimenisionL: "",
                        cartoonDimenisionW: "",
                        cartoonWeight: "",
                        cartoonPrice: "",
                        cartoonDiscountPrice: "",
                        cartoonDiscount: "0",
                        cartoonQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: 0,
                          },
                        ],
                      },
                    };
                  }
                  if (!pieceFound) {
                    productTemp[3].isChecked = false;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        pieceDimenisionH: "",
                        pieceDimenisionL: "",
                        pieceDimenisionW: "",
                        pieceWeight: "",
                        piecePrice: "",
                        pieceDiscountPrice: "",
                        pieceDiscount: "0",
                        pieceQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: 0,
                          },
                        ],
                      },
                    };
                  }
                  if (!dozenFound) {
                    productTemp[2].isChecked = false;
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        dozenDimenisionH: "",
                        dozenDimenisionL: "",
                        dozenDimenisionW: "",
                        dozenWeight: "",
                        dozenPrice: "",
                        dozenDiscountPrice: "",
                        dozenDiscount: "0",
                        dozenQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: 0,
                          },
                        ],
                      },
                    };
                  }
                }
              );
              response.product["variants"][variantIndex]["variant"][
                "combinationKey"
              ] = option + "_" + key;
              tempCombinations.push(combinationTemp);
              tempCombinationValidation.push(combinationValidationTemp);
            }
          );
          temp.isDraft = response.product.draft;
          temp.combinations = tempCombinations;
          tempValidation.combinations = tempCombinationValidation;
        } else {
          let combinationTemp: any = {};
          let combinationValidationTemp: any = {
            title: false,
            dimensions: {
              cartoonDozens: false,
              piecesDozens: false,
              cartoonPieces: false,
              cartoonPrice: false,
              cartoonDiscount: false,
              cartoonDiscountPrice: false,
              cartoonDimenisionL: false,
              cartoonDimenisionW: false,
              cartoonDimenisionH: false,
              cartoonWeight: false,
              cartoonQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              dozenPrice: false,
              dozenDiscount: false,
              dozenDiscountPrice: false,
              dozenDimenisionL: false,
              dozenDimenisionW: false,
              dozenDimenisionH: false,
              dozenWeight: false,
              dozenQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              piecePrice: false,
              pieceDiscount: false,
              pieceDiscountPrice: false,
              pieceDimenisionL: false,
              pieceDimenisionW: false,
              pieceDimenisionH: false,
              pieceWeight: false,
              pieceQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
            },
            validation: false,
          };
          combinationTemp = {
            title: "",
            combinationKey: "",
            dimensions: {
              cartoonDozens: 0,
              piecesDozens: 0,
              cartoonPrice: 0,
              cartoonPieces: null,
              cartoonDiscount: "0",
              cartoonDiscountPrice: null,
              cartoonDimenisionL: null,
              cartoonDimenisionW: null,
              cartoonDimenisionH: null,
              cartoonWeight: null,
              cartoonQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              dozenPrice: null,
              dozenDiscount: "0",
              dozenDiscountPrice: null,
              dozenDimenisionL: null,
              dozenDimenisionW: null,
              dozenDimenisionH: null,
              dozenWeight: null,
              dozenQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              piecePrice: null,
              pieceDiscount: "0",
              pieceDiscountPrice: null,
              pieceDimenisionL: null,
              pieceDimenisionW: null,
              pieceDimenisionH: null,
              pieceWeight: null,
              pieceQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              product: [
                {
                  id: CartonWithDozens,
                  value: "Carton (Dozens inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: CartonWithPieces,
                  value: "Carton (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Dozen,
                  value: "Dozen (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Piece,
                  value: "Pieces",
                  isChecked: false,
                  isDisabled: false,
                },
              ],
              selectedCartoonId: "",
              selectedDozenId: "",
              selectedPiecesId: "",
              isOpen: false,
              images: [],
              imageReader: [],
            },
          };
          tempCombinations.push(combinationTemp);
          tempCombinationValidation.push(combinationValidationTemp);
          temp.isDraft = response.product.draft;
          temp.combinations = tempCombinations;
          tempValidation.combinations = tempCombinationValidation;
        }
        setGeneralDataValidation(tempValidation);
        setInitialGeneralData(response.product);
        setGeneralData(temp);
        setInitialProductData(JSON.parse(JSON.stringify(temp)));
        setInitCombinations(temp.combinations);
        response.defaultItems.categories.map((catVal: any) => {
          if (catVal.categories.length) {
            catTemp.push(catVal);
          }
        });
        setCategories(catTemp);
        setVariants(response.defaultItems.variants);
        setCountries(response.defaultItems.countries);
        setBrands(response.defaultItems.brands);
        setTechnicalFields(response.defaultItems.technicalFields);
        setCurrentTab({
          name: "General info",
          content: (
            <General
              onGeneralDataChange={onGeneralDataChange}
              generalData={temp}
              categories={catTemp}
              countries={response.defaultItems.countries}
              technicalFields={response.defaultItems.technicalFields}
              variants={response.defaultItems.variants}
              brands={response.defaultItems.brands}
              validations={tempValidation}
              onValidationChange={onValidationChange}
              onCategoryChanges={() => {
                setIsChanged(true);
              }}
            />
          ),
          value: 0,
        });
      }
      setFetchLoader(false);
    })();
    // setDisabled(true);
  }, []);
  const navigate = useNavigate();
  const [tab, setTab] = useState([
    {
      name: "General info",
      content: <General />,
      value: 0,
    },
    { name: "Price & dimensions", content: <PriceDimesions />, value: 1 },
    { name: "Technical details", content: <TechnicalDetails />, value: 2 },
    { name: "Product images", content: <ProductImages />, value: 3 },
  ]);
  const [disabled, setDisabled] = useState(false);
  const [generalData, setGeneralData] = useState<any>({
    primaryCategory: "",
    subCategory: "",
    defaultSubCategory: [],
    defaultGroupCategory: [],
    groupCategory: "",
    productTitle: "",
    country: "",
    brand: "",
    taxFree: true,
    description: "",
    variants: [],
    noneSelected: false,
    productName: "",
    isDraft: false,
    combinations: [
      {
        title: "",
        dimensions: {
          cartoonDozens: 0,
          piecesDozens: 0,
          cartoonPieces: 0,
          cartoonPrice: null,
          cartoonDiscount: "0",
          cartoonDiscountPrice: null,
          cartoonDimenisionL: null,
          cartoonDimenisionW: null,
          cartoonDimenisionH: null,
          cartoonWeight: null,
          cartoonQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          dozenPrice: null,
          dozenDiscount: "0",
          dozenDiscountPrice: null,
          dozenDimenisionL: null,
          dozenDimenisionW: null,
          dozenDimenisionH: null,
          dozenWeight: null,
          dozenQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          piecePrice: null,
          pieceDiscount: "0",
          pieceDiscountPrice: null,
          pieceDimenisionL: null,
          pieceDimenisionW: null,
          pieceDimenisionH: null,
          pieceWeight: null,
          pieceQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          product: [
            {
              id: CartonWithDozens,
              value: "Carton (Dozens inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: CartonWithPieces,
              value: "Carton (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Dozen,
              value: "Dozen (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            { id: Piece, value: "Pieces", isChecked: false, isDisabled: false },
          ],
          selectedCartoonId: "",
          selectedDozenId: "",
          selectedPiecesId: "",
          isOpen: false,
          images: [],
          imageReader: [],
        },
      },
    ],
    searchTag: {
      inputValue: '',
      options: [],
    },
  });
  const [initialGeneralData, setInitialGeneralData] = useState<any>({
    primaryCategory: "",
    subCategory: "",
    defaultSubCategory: [],
    defaultGroupCategory: [],
    groupCategory: "",
    productTitle: "",
    country: "",
    brand: "",
    taxFree: true,
    description: "",
    variants: [],
    noneSelected: false,
    productName: "",
    isDraft: false,
    combinations: [
      {
        title: "",
        dimensions: {
          cartoonDozens: 0,
          piecesDozens: 0,
          cartoonPieces: 0,
          cartoonPrice: null,
          cartoonDiscount: "0",
          cartoonDiscountPrice: null,
          cartoonDimenisionL: null,
          cartoonDimenisionW: null,
          cartoonDimenisionH: null,
          cartoonWeight: null,
          cartoonQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          dozenPrice: null,
          dozenDiscount: "0",
          dozenDiscountPrice: null,
          dozenDimenisionL: null,
          dozenDimenisionW: null,
          dozenDimenisionH: null,
          dozenWeight: null,
          dozenQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          piecePrice: null,
          pieceDiscount: "0",
          pieceDiscountPrice: null,
          pieceDimenisionL: null,
          pieceDimenisionW: null,
          pieceDimenisionH: null,
          pieceWeight: null,
          pieceQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          product: [
            {
              id: CartonWithDozens,
              value: "Carton (Dozens inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: CartonWithPieces,
              value: "Carton (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Dozen,
              value: "Dozen (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Piece,
              value: "Pieces",
              isChecked: false,
              isDisabled: false,
            },
          ],
          selectedCartoonId: "",
          selectedDozenId: "",
          selectedPiecesId: "",
          isOpen: false,
          images: [],
          imageReader: [],
        },
      },
    ],
  });
  console.log("initialGeneralData", initialProductData, generalData);
  const [generalDataValidation, setGeneralDataValidation] = useState<any>({
    primaryCategory: false,
    subCategory: false,
    groupCategory: false,
    productTitle: false,
    country: false,
    brand: false,
    description: false,
    variants: false,
    noneSelected: false,
    productName: false,
    isDraft: false,
    minimumCombinations: false,
    selectedVariants: [],
    combinations: [
      {
        title: false,
        validation: false,
        dimensions: {
          cartoonDozens: false,
          piecesDozens: false,
          cartoonPieces: false,
          cartoonPrice: false,
          cartoonDiscount: false,
          cartoonDiscountPrice: false,
          cartoonDimenisionL: false,
          cartoonDimenisionW: false,
          cartoonDimenisionH: false,
          cartoonWeight: false,
          cartoonQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          dozenPrice: false,
          dozenDiscount: false,
          dozenDiscountPrice: false,
          dozenDimenisionL: false,
          dozenDimenisionW: false,
          dozenDimenisionH: false,
          dozenWeight: false,
          dozenQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          piecePrice: false,
          pieceDiscount: false,
          pieceDiscountPrice: false,
          pieceDimenisionL: false,
          pieceDimenisionW: false,
          pieceDimenisionH: false,
          pieceWeight: false,
          pieceQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
        },
      },
    ],
  });
  console.log("generalData", generalData);
  const [priceValidation, setPriceValidation] = useState(false);
  const onGeneralDataChange = (data: any) => {
    setGeneralData(data);
  };
  const onValidationChange = (data: any) => {
    setGeneralDataValidation(data);
  };
  const [imageString, setImageString] = useState();
  const [productAsDraftmodalShow, setProductAsDraftModalShow] = useState(false);
  const [productAddedmodalShow, setProductAddedModalShow] = useState(false);
  const [productGuidelinesmodalShow, setProductGuidelinesModalShow] =
    useState(false);
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <span
            className={clsx(
              "nav-link disabled text-active-dark",
              current.name === tab.name ? "active" : " ",
              currentTab.value !== tab.value
                ? disabled
                  ? "disabled"
                  : ""
                : "",
              loading ? "disabled" : ""
            )}
          >
            {tab.name}
          </span>
        </li>
      );
    });
    return allTabs;
  };
  const handleSelectTab = async (tab: any) => {
    let generalTemp = JSON.parse(JSON.stringify({ ...generalData }));
    if (tab.value === 1 && currentTab.value === 0) {
      let validations = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      generalTemp.combinations = [];
      let generalTabValidations = await checkGeneralTabValidation(generalTemp);
      let tempCombinations: any = [];
      let tempCombinationValidation: any = [];
      if (initialGeneralData["variants"].length) {
        initialGeneralData["variants"].map(
          (variantVal: any, variantIndex: number) => {
            let combinationTemp: any = {
              _id: variantVal.variant._id,
            };
            let combinationValidationTemp: any = {
              title: false,
              validation: false,
              dimensions: {
                cartoonDozens: false,
                piecesDozens: false,
                cartoonPieces: false,
                cartoonPrice: false,
                cartoonDiscount: false,
                cartoonDiscountPrice: false,
                cartoonDimenisionL: false,
                cartoonDimenisionW: false,
                cartoonDimenisionH: false,
                cartoonWeight: false,
                cartoonQuantities: [
                  {
                    min: false,
                    max: false,
                    discount: false,
                  },
                ],
                dozenPrice: false,
                dozenDiscount: false,
                dozenDiscountPrice: false,
                dozenDimenisionL: false,
                dozenDimenisionW: false,
                dozenDimenisionH: false,
                dozenWeight: false,
                dozenQuantities: [
                  {
                    min: false,
                    max: false,
                    discount: false,
                  },
                ],
                piecePrice: false,
                pieceDiscount: false,
                pieceDiscountPrice: false,
                pieceDimenisionL: false,
                pieceDimenisionW: false,
                pieceDimenisionH: false,
                pieceWeight: false,
                pieceQuantities: [
                  {
                    min: false,
                    max: false,
                    discount: false,
                  },
                ],
              },
            };
            let imagesTemp: any = [];
            variantVal.variant.media.map((val: any, index: number) => {
              imagesTemp.push({ ...val, id: index, order: index });
            });
            combinationTemp = {
              ...combinationTemp,
              title: variantVal.variant.title,
              inventoryInfo: variantVal.variant.inventoryInfo,
              dimensions: {
                cartoonDozens: variantVal.variant.dozensInCarton,
                piecesDozens: variantVal.variant.piecesInDozen,
                cartoonPieces: variantVal.variant.piecesInCarton
                  ? variantVal.variant.piecesInCarton
                  : "0",
                product: [
                  {
                    id: CartonWithDozens,
                    value: "Carton (Dozens inside)",
                    isChecked: false,
                    isDisabled: false,
                  },
                  {
                    id: CartonWithPieces,
                    value: "Carton (Pieces inside)",
                    isChecked: false,
                    isDisabled: false,
                  },
                  {
                    id: Dozen,
                    value: "Dozen (Pieces inside)",
                    isChecked: false,
                    isDisabled: false,
                  },
                  {
                    id: Piece,
                    value: "Pieces",
                    isChecked: false,
                    isDisabled: false,
                  },
                ],
                images: imagesTemp,
              },
            };
            let productTemp: any = [...combinationTemp.dimensions.product];
            let cartoonFound = false;
            let pieceFound = false;
            let dozenFound = false;
            variantVal.variant.quantityTypes.map(
              (quantVal: any, index: number) => {
                if (
                  quantVal.type === CartonWithDozens ||
                  quantVal.type === CartonWithPieces
                ) {
                  productTemp[0].isChecked = quantVal.type === CartonWithDozens;
                  productTemp[1].isChecked = quantVal.type === CartonWithPieces;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      cartoonDimenisionH: quantVal.dimensions.height,
                      cartoonDimenisionL: quantVal.dimensions.length,
                      cartoonDimenisionW: quantVal.dimensions.width,
                      cartoonWeight: quantVal.dimensions.weight,
                      cartoonPrice: quantVal.amount,
                      cartoonDiscountPrice: quantVal.discountAmt,
                      cartoonDiscount: "0",
                    },
                  };
                  if (quantVal.discountAmtEnabled) {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        cartoonDiscount: "0",
                      },
                    };
                  }
                  if (quantVal.discountsByQuantities.length) {
                    let discount: any = [];
                    quantVal.discountsByQuantities.map((discVal: any) => {
                      discount.push({
                        min: discVal.min,
                        max: discVal.max,
                        discount: discVal.discountAmt,
                      });
                    });
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        cartoonQuantities: discount,
                        cartoonDiscount: "1",
                      },
                    };
                  } else {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        cartoonQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                      },
                    };
                  }
                  cartoonFound = true;
                }
                if (quantVal.type === Piece) {
                  productTemp[3].isChecked = true;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      pieceDimenisionH: quantVal.dimensions.height,
                      pieceDimenisionL: quantVal.dimensions.length,
                      pieceDimenisionW: quantVal.dimensions.width,
                      pieceWeight: quantVal.dimensions.weight,
                      piecePrice: quantVal.amount,
                      pieceDiscountPrice: quantVal.discountAmt,
                      pieceDiscount: "0",
                    },
                  };
                  if (quantVal.discountAmtEnabled) {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        pieceDiscount: "0",
                      },
                    };
                  }
                  if (quantVal.discountsByQuantities.length) {
                    let discount: any = [];
                    quantVal.discountsByQuantities.map((discVal: any) => {
                      discount.push({
                        min: discVal.min,
                        max: discVal.max,
                        discount: discVal.discountAmt,
                      });
                    });
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        pieceQuantities: discount,
                        pieceDiscount: "1",
                      },
                    };
                  } else {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        pieceQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                      },
                    };
                  }
                  pieceFound = true;
                }
                if (quantVal.type === Dozen) {
                  productTemp[2].isChecked = true;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      dozenDimenisionH: quantVal.dimensions.height,
                      dozenDimenisionL: quantVal.dimensions.length,
                      dozenDimenisionW: quantVal.dimensions.width,
                      dozenWeight: quantVal.dimensions.weight,
                      dozenPrice: quantVal.amount,
                      dozenDiscountPrice: quantVal.discountAmt,
                      dozenDiscount: "0",
                    },
                  };
                  if (quantVal.discountAmtEnabled) {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        dozenDiscount: "0",
                      },
                    };
                  }
                  if (quantVal.discountsByQuantities.length) {
                    let discount: any = [];
                    quantVal.discountsByQuantities.map((discVal: any) => {
                      discount.push({
                        min: discVal.min,
                        max: discVal.max,
                        discount: discVal.discountAmt,
                      });
                    });
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        dozenQuantities: discount,
                        dozenDiscount: "1",
                      },
                    };
                  } else {
                    combinationTemp = {
                      ...combinationTemp,
                      dimensions: {
                        ...combinationTemp.dimensions,
                        dozenQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                      },
                    };
                  }
                  dozenFound = true;
                }
                // Reset values for types that are not encountered
                if (!cartoonFound) {
                  productTemp[0].isChecked = false;
                  productTemp[1].isChecked = false;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      cartoonDimenisionH: "",
                      cartoonDimenisionL: "",
                      cartoonDimenisionW: "",
                      cartoonWeight: "",
                      cartoonPrice: "",
                      cartoonDiscountPrice: "",
                      cartoonDiscount: "0",
                      cartoonQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: 0,
                        },
                      ],
                    },
                  };
                }
                if (!pieceFound) {
                  productTemp[3].isChecked = false;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      pieceDimenisionH: "",
                      pieceDimenisionL: "",
                      pieceDimenisionW: "",
                      pieceWeight: "",
                      piecePrice: "",
                      pieceDiscountPrice: "",
                      pieceDiscount: "0",
                      pieceQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: 0,
                        },
                      ],
                    },
                  };
                }
                if (!dozenFound) {
                  productTemp[2].isChecked = false;
                  combinationTemp = {
                    ...combinationTemp,
                    dimensions: {
                      ...combinationTemp.dimensions,
                      dozenDimenisionH: "",
                      dozenDimenisionL: "",
                      dozenDimenisionW: "",
                      dozenWeight: "",
                      dozenPrice: "",
                      dozenDiscountPrice: "",
                      dozenDiscount: "0",
                      dozenQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: 0,
                        },
                      ],
                    },
                  };
                }
              }
            );
            tempCombinations.push(combinationTemp);
            tempCombinationValidation.push(combinationValidationTemp);
          }
        );
        generalTemp.combinations = tempCombinations;
        validations.combinations = tempCombinationValidation;
      } else {
        let combinationTemp: any = {};
        let combinationValidationTemp: any = {
          title: false,
          validation: false,
          dimensions: {
            cartoonDozens: false,
            piecesDozens: false,
            cartoonPieces: false,
            cartoonPrice: false,
            cartoonDiscount: false,
            cartoonDiscountPrice: false,
            cartoonDimenisionL: false,
            cartoonDimenisionW: false,
            cartoonDimenisionH: false,
            cartoonWeight: false,
            cartoonQuantities: [
              {
                min: false,
                max: false,
                discount: false,
              },
            ],
            dozenPrice: false,
            dozenDiscount: false,
            dozenDiscountPrice: false,
            dozenDimenisionL: false,
            dozenDimenisionW: false,
            dozenDimenisionH: false,
            dozenWeight: false,
            dozenQuantities: [
              {
                min: false,
                max: false,
                discount: false,
              },
            ],
            piecePrice: false,
            pieceDiscount: false,
            pieceDiscountPrice: false,
            pieceDimenisionL: false,
            pieceDimenisionW: false,
            pieceDimenisionH: false,
            pieceWeight: false,
            pieceQuantities: [
              {
                min: false,
                max: false,
                discount: false,
              },
            ],
          },
        };
        combinationTemp = {
          title: "",
          dimensions: {
            cartoonDozens: 0,
            piecesDozens: 0,
            cartoonPrice: 0,
            cartoonPieces: null,
            cartoonDiscount: "0",
            cartoonDiscountPrice: null,
            cartoonDimenisionL: null,
            cartoonDimenisionW: null,
            cartoonDimenisionH: null,
            cartoonWeight: null,
            cartoonQuantities: [
              {
                min: 1,
                max: 5,
                discount: null,
              },
            ],
            dozenPrice: null,
            dozenDiscount: "0",
            dozenDiscountPrice: null,
            dozenDimenisionL: null,
            dozenDimenisionW: null,
            dozenDimenisionH: null,
            dozenWeight: null,
            dozenQuantities: [
              {
                min: 1,
                max: 5,
                discount: null,
              },
            ],
            piecePrice: null,
            pieceDiscount: "0",
            pieceDiscountPrice: null,
            pieceDimenisionL: null,
            pieceDimenisionW: null,
            pieceDimenisionH: null,
            pieceWeight: null,
            pieceQuantities: [
              {
                min: 1,
                max: 5,
                discount: null,
              },
            ],
            product: [
              {
                id: CartonWithDozens,
                value: "Carton (Dozens inside)",
                isChecked: false,
                isDisabled: false,
              },
              {
                id: CartonWithPieces,
                value: "Carton (Pieces inside)",
                isChecked: false,
                isDisabled: false,
              },
              {
                id: Dozen,
                value: "Dozen (Pieces inside)",
                isChecked: false,
                isDisabled: false,
              },
              {
                id: Piece,
                value: "Pieces",
                isChecked: false,
                isDisabled: false,
              },
            ],
            selectedCartoonId: "",
            selectedDozenId: "",
            selectedPiecesId: "",
            isOpen: false,
            images: [],
            imageReader: [],
          },
        };
        tempCombinations.push(combinationTemp);
        tempCombinationValidation.push(combinationValidationTemp);
        generalTemp.combinations = tempCombinations;
        validations.combinations = tempCombinationValidation;
      }
      if (!generalTabValidations) {
        if (!generalTemp.noneSelected) {
          let selectedVariant: any = [];
          let data: any = [];
          generalTemp.variants.map((variantVal: any) => {
            if (variantVal.isSelected === true) {
              let temp: any = [];
              variantVal.categories[0].options.map((optionVal: any) => {
                temp.push({ title: optionVal.title, _id: variantVal._id });
              });
              selectedVariant.push({
                options: variantVal.categories[0].options,
                _id: variantVal._id,
              });
              data.push(temp);
              console.log(variantVal.isSelected);
            }
          });
          let temp = { ...generalTemp };
          if (selectedVariant.length) {
            temp.selectedVariant = selectedVariant;
            if (data.length) {
              console.log(data);
              if (data[0].length === 0) {
                let imageString: any = [];
                data[0].map((val: any) =>
                  imageString.push({
                    ...val,
                    title: `${generalTemp.productTitle} (${val.title})`,
                    id: val._id,
                  })
                );
                let tempData: any = [];
                let validTemp: any = [];
                imageString.map((val: any) => {
                  const matchedVariant = initialGeneralData.variants.find(
                    (variant: any) => {
                      return (
                        variant.variant.combinationKey == val.combinationKey
                      );
                    }
                  );
                  if (matchedVariant && Object.keys(matchedVariant).length) {
                    validTemp.push({
                      title: false,
                      dimensions: validations.combinations[0].dimensions,
                      validation: false,
                    });
                    return tempData.push({
                      title: val.title,
                      id: val.id,
                      inventoryInfo: generalTemp.combinations[0].inventoryInfo,
                      dimensions: generalTemp.combinations[0].dimensions,
                      _id: generalTemp.combinations[0]
                        ? generalTemp.combinations[0]._id
                          ? generalTemp.combinations[0]._id
                          : null
                        : null,
                    });
                  } else {
                    validTemp.push({
                      title: false,
                      dimensions: validations.combinations[0].dimensions,
                      validation: false,
                    });
                    return tempData.push({
                      title: val.title,
                      id: val.id,
                      _id: null,
                      inventoryInfo: [{ quantityTypes: [] }],
                      dimensions: {
                        cartoonDozens: 0,
                        piecesDozens: 0,
                        cartoonPrice: null,
                        cartoonPieces: 0,
                        cartoonDiscount: "0",
                        cartoonDiscountPrice: null,
                        cartoonDimenisionL: null,
                        cartoonDimenisionW: null,
                        cartoonDimenisionH: null,
                        cartoonWeight: null,
                        cartoonQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        dozenPrice: null,
                        dozenDiscount: "0",
                        dozenDiscountPrice: null,
                        dozenDimenisionL: null,
                        dozenDimenisionW: null,
                        dozenDimenisionH: null,
                        dozenWeight: null,
                        dozenQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        piecePrice: null,
                        pieceDiscount: "0",
                        pieceDiscountPrice: null,
                        pieceDimenisionL: null,
                        pieceDimenisionW: null,
                        pieceDimenisionH: null,
                        pieceWeight: null,
                        pieceQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        product: [
                          {
                            id: CartonWithDozens,
                            value: "Carton (Dozens inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: Piece,
                            value: "Carton (Pieces inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: Dozen,
                            value: "Dozen (Pieces inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: CartonWithPieces,
                            value: "Pieces",
                            isChecked: false,
                            isDisabled: false,
                          },
                        ],
                        selectedCartoonId: "",
                        selectedDozenId: "",
                        selectedPiecesId: "",
                        isOpen: false,
                        images: [],
                        imageReader: [],
                      },
                    });
                  }
                });
                validations.combinations = validTemp;
                temp.combinations = tempData;
                setGeneralData(temp);
                setGeneralDataValidation(validations);
                setNavTab(tab.value, temp, validations);
              } else {
                let imageString = await combine(data);
                let updatedImageString = imageString.map((val: any) => {
                  return {
                    ...val,
                    id: val._id,
                    title: `${generalTemp.productTitle} (${val.title})`,
                  };
                });
                let tempData: any = [];
                let validTemp: any = [];
                updatedImageString.map((val: any, index: any) => {
                  const matchedVariant = initialGeneralData.variants.find(
                    (variant: any) => {
                      return (
                        variant.variant.combinationKey == val.combinationKey
                      );
                    }
                  );
                  validTemp.push({
                    title: false,
                    validation: false,
                    dimensions:
                      generalDataValidation.combinations[0].dimensions,
                  });
                  if (matchedVariant && Object.keys(matchedVariant).length) {
                    generalTemp.combinations.map(
                      (combVal: any, combIndex: number) => {
                        if (combVal._id == matchedVariant.variant._id) {
                          return tempData.push({
                            title: val.title,
                            id: val.id,
                            _id: generalTemp.combinations[combIndex]
                              ? generalTemp.combinations[combIndex]._id
                                ? generalTemp.combinations[combIndex]._id
                                : null
                              : null,
                            inventoryInfo: generalTemp.combinations[combIndex]
                              ? generalTemp.combinations[combIndex]
                                .inventoryInfo
                              : { quantityTypes: [] },
                            dimensions: generalTemp.combinations[combIndex]
                              ? generalTemp.combinations[combIndex].dimensions
                              : {
                                cartoonDozens: 0,
                                piecesDozens: 0,
                                cartoonPrice: null,
                                cartoonPieces: 0,
                                cartoonDiscount: '0',
                                cartoonDiscountPrice: null,
                                cartoonDimenisionL: null,
                                cartoonDimenisionW: null,
                                cartoonDimenisionH: null,
                                cartoonWeight: null,
                                cartoonQuantities: [
                                  {
                                    min: 1,
                                    max: 5,
                                    discount: null,
                                  },
                                ],
                                dozenPrice: null,
                                dozenDiscount: '0',
                                dozenDiscountPrice: null,
                                dozenDimenisionL: null,
                                dozenDimenisionW: null,
                                dozenDimenisionH: null,
                                dozenWeight: null,
                                dozenQuantities: [
                                  {
                                    min: 1,
                                    max: 5,
                                    discount: null,
                                  },
                                ],
                                piecePrice: null,
                                pieceDiscount: '0',
                                pieceDiscountPrice: null,
                                pieceDimenisionL: null,
                                pieceDimenisionW: null,
                                pieceDimenisionH: null,
                                pieceWeight: null,
                                pieceQuantities: [
                                  {
                                    min: 1,
                                    max: 5,
                                    discount: null,
                                  },
                                ],
                                product: [
                                  {
                                    id: CartonWithDozens,
                                    value: 'Carton (Dozens inside)',
                                    isChecked: false,
                                    isDisabled: false,
                                  },
                                  {
                                    id: Piece,
                                    value: 'Carton (Pieces inside)',
                                    isChecked: false,
                                    isDisabled: false,
                                  },
                                  {
                                    id: Dozen,
                                    value: 'Dozen (Pieces inside)',
                                    isChecked: false,
                                    isDisabled: false,
                                  },
                                  {
                                    id: CartonWithPieces,
                                    value: 'Pieces',
                                    isChecked: false,
                                    isDisabled: false,
                                  },
                                ],
                                selectedCartoonId: '',
                                selectedDozenId: '',
                                selectedPiecesId: '',
                                isOpen: false,
                                images: [],
                                imageReader: [],
                              },
                          });
                        }
                      }
                    );
                  } else {
                    return tempData.push({
                      title: val.title,
                      id: val.id,
                      _id: null,
                      inventoryInfo: [{ quantityTypes: [] }],
                      dimensions: {
                        cartoonDozens: 0,
                        piecesDozens: 0,
                        cartoonPrice: null,
                        cartoonPieces: 0,
                        cartoonDiscount: "0",
                        cartoonDiscountPrice: null,
                        cartoonDimenisionL: null,
                        cartoonDimenisionW: null,
                        cartoonDimenisionH: null,
                        cartoonWeight: null,
                        cartoonQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        dozenPrice: null,
                        dozenDiscount: "0",
                        dozenDiscountPrice: null,
                        dozenDimenisionL: null,
                        dozenDimenisionW: null,
                        dozenDimenisionH: null,
                        dozenWeight: null,
                        dozenQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        piecePrice: null,
                        pieceDiscount: "0",
                        pieceDiscountPrice: null,
                        pieceDimenisionL: null,
                        pieceDimenisionW: null,
                        pieceDimenisionH: null,
                        pieceWeight: null,
                        pieceQuantities: [
                          {
                            min: 1,
                            max: 5,
                            discount: null,
                          },
                        ],
                        product: [
                          {
                            id: CartonWithDozens,
                            value: "Carton (Dozens inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: CartonWithPieces,
                            value: "Carton (Pieces inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: Dozen,
                            value: "Dozen (Pieces inside)",
                            isChecked: false,
                            isDisabled: false,
                          },
                          {
                            id: Piece,
                            value: "Pieces",
                            isChecked: false,
                            isDisabled: false,
                          },
                        ],
                        selectedCartoonId: "",
                        selectedDozenId: "",
                        selectedPiecesId: "",
                        isOpen: false,
                        images: [],
                        imageReader: [],
                      },
                    });
                  }
                });
                temp.combinations = tempData;
                validations.combinations = validTemp;
                setGeneralDataValidation(validations);
                setGeneralData(temp);
                setNavTab(tab.value, temp, validations);
              }
            } else {
              let tempData: any = [];
              let validTemp: any = [];
              tempData.push({
                title: generalTemp.productTitle,
                inventoryInfo: generalTemp.combinations[0].inventoryInfo,
                id: "",
                dimensions: generalTemp.combinations[0].dimensions,
              });
              validTemp.push({
                title: false,
                validation: false,
                dimensions: generalDataValidation.combinations[0].dimensions,
              });
              temp.combinations = tempData;
              validations.combinations = validTemp;
              setGeneralDataValidation(validations);
              setNavTab(tab.value, temp, validations);
            }
          }
          if (tab.value > currentTab.value) {
            if (temp.combinations.length > 1) setShowVariantModal(true);
            else setNavTab(tab.value, temp, validations);
          } else {
            setNavTab(tab.value, temp, validations);
          }
        } else {
          let tempData: any = [];
          let validTemp: any = [];
          tempData.push({
            title: generalTemp.productTitle,
            dimensions: generalTemp.combinations[0].dimensions,
            inventoryInfo: generalTemp.combinations[0].inventoryInfo,
          });
          validTemp.push({
            title: false,
            dimensions: validations.combinations[0].dimensions,
            validation: false,
          });
          validations.combinations = validTemp;
          generalTemp.combinations = tempData;
          setNavTab(tab.value, generalTemp, validations);
        }
      }
    } else if (tab.value === 2) {
      let priceDimensionTabValidations = await checkPriceDimensionTabValidation(
        generalTemp
      );
      if (!priceDimensionTabValidations) {
        let validations = JSON.parse(
          JSON.stringify({ ...generalDataValidation })
        );
        if (isChanged || generalTemp.isDraft) {
          if (generalTemp.defaultTechnicalFields.length) {
            let filterTechnical: any = [];
            let filterTechnicalValidation: any = [];
            technicalFields.map((techVal: any) => {
              if (techVal.category === generalData.primaryCategory) {
                let temp: any = [];
                if (techVal.options.length) {
                  techVal.options.map((optionsVal: any) => {
                    temp.push({
                      ...optionsVal,
                      value: optionsVal.title,
                      label: optionsVal.title,
                    });
                  });
                }
                filterTechnical.push({ ...techVal, options: temp });
                filterTechnicalValidation.push({ valid: false });
              }
            });
            if (generalTemp.defaultTechnicalFields.length) {
              generalTemp.defaultTechnicalFields = filterTechnical;
            }
            validations.defaultTechnicalFields = filterTechnicalValidation;
          }
        }
        setGeneralData(generalTemp);
        setGeneralDataValidation(validations);
        setNavTab(tab.value, generalTemp, validations);
      }
    } else if (tab.value === 3) {
      let technicalTabValidations = await checkTechnicalDetailsValiadtions(
        generalTemp
      );
      if (!technicalTabValidations) {
        let data: any = [];
        let selectedVariant: any = [];
        generalTemp.variants.map((variantVal: any) => {
          if (variantVal.isSelected === true) {
            let temp: any = [];
            variantVal.categories[0].options.map((optionVal: any) => {
              temp.push({ title: optionVal.title, _id: variantVal._id });
            });
            selectedVariant.push({
              options: variantVal.categories[0].options,
              _id: variantVal._id,
            });
            data.push(temp);
          }
        });
        setNavTab(tab.value, generalTemp, generalDataValidation);
      }
    } else {
      setNavTab(tab.value, generalTemp, generalDataValidation);
    }
  };
  const checkGeneralTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    let valid = [];
    if (generalDataTemp.primaryCategory === "") {
      generalValidationTemp.primaryCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.subCategory === "") {
      generalValidationTemp.subCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.productTitle === "") {
      valid.push(true);
      generalValidationTemp.productTitle = true;
    }
    if (generalDataTemp.country === "") {
      generalValidationTemp.country = true;
      valid.push(true);
    }
    if (generalDataTemp.brand === "") {
      valid.push(true);
      generalValidationTemp.brand = true;
    }
    if (generalDataTemp.taxFree === false) {
      if (generalDataTemp.productTax === "") {
        generalValidationTemp.productTax = true;
        valid.push(true);
      }
    }
    if (generalDataTemp.description === "") {
      valid.push(true);
      generalValidationTemp.description = true;
    }
    let selectedVariant: any = [];
    let data: any = [];
    let validations = JSON.parse(JSON.stringify({ ...generalDataValidation }));
    generalDataTemp.variants.map((variantVal: any) => {
      if (variantVal.isSelected === true) {
        let temp: any = [];
        variantVal.categories[0].options.map((optionVal: any) => {
          temp.push({ title: optionVal.title, _id: variantVal._id });
        });
        selectedVariant.push({
          options: variantVal.categories[0].options,
          _id: variantVal._id,
        });
        validations.selectedVariants.push(false);
        data.push(temp);
      }
    });
    if (!generalDataTemp.noneSelected) {
      if (selectedVariant.length) {
        let selectValTemp: any = [];
        selectedVariant.map((selectVal: any) => {
          if (selectVal.options.length) {
            selectValTemp.push(false);
          } else {
            valid.push(true);
            selectValTemp.push(true);
          }
        });
        generalValidationTemp.selectedVariants = selectValTemp;
      } else {
        valid.push(true);
        generalValidationTemp.variants = true;
      }
    } else {
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkPriceDimensionTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid = [];
    if (generalDataTemp.combinations.length) {
      let allTrue = generalDataTemp.combinations.every(({ dimensions }: any) =>
        dimensions.product.some(({ isChecked }: any) => isChecked === true)
      );
      generalDataTemp.combinations.map(({ dimensions }: any, index: number) => {
        generalDataValidation.combinations[index].validation =
          !dimensions.product.some(({ isChecked }: any) => isChecked === true);
      });
      if (!allTrue) {
        valid.push(true);
        generalDataValidation.minimumCombinations = true;
      } else {
        generalDataValidation.minimumCombinations = false;
        generalDataTemp.combinations.map((combVal: any, index: number) => {
          let combinationValidation: any = [];
          if (combVal.dimensions.product[0].isChecked) {
            if (
              !combVal.dimensions.cartoonDozens ||
              combVal.dimensions.cartoonDozens === "" ||
              combVal.dimensions.cartoonDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDozens = true;
            }
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[1].isChecked) {
            if (
              !combVal.dimensions.cartoonPieces ||
              combVal.dimensions.cartoonPieces === "" ||
              combVal.dimensions.cartoonPieces == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPieces = true;
            }
          }
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            if (
              !combVal.dimensions.cartoonPrice ||
              combVal.dimensions.cartoonPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPrice = true;
            }
            if (combVal.dimensions.cartoonDiscount === "0") {
              if (
                combVal.dimensions.cartoonDiscountPrice &&
                combVal.dimensions.cartoonDiscountPrice !== "" &&
                combVal.dimensions.cartoonPrice &&
                combVal.dimensions.cartoonPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.cartoonDiscountPrice) >
                  parseInt(combVal.dimensions.cartoonPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.cartoonDiscountPrice = true;
                }
              }
            } else {
              if (combVal.dimensions.cartoonQuantities.length) {
              }
            }
            if (
              !combVal.dimensions.cartoonDimenisionL ||
              combVal.dimensions.cartoonDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionL = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionW ||
              combVal.dimensions.cartoonDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionW = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionH ||
              combVal.dimensions.cartoonDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionH = true;
            }
            if (
              !combVal.dimensions.cartoonWeight ||
              combVal.dimensions.cartoonWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonWeight = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.dozenPrice ||
              combVal.dimensions.dozenPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenPrice =
                true;
            }
            if (combVal.dimensions.dozenDiscount === "0") {
              if (
                combVal.dimensions.dozenDiscountPrice &&
                combVal.dimensions.dozenDiscountPrice !== "" &&
                combVal.dimensions.dozenPrice &&
                combVal.dimensions.dozenPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.dozenDiscountPrice) >
                  parseInt(combVal.dimensions.dozenPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.dozenDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.dozenDimenisionL ||
              combVal.dimensions.dozenDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionL = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionW ||
              combVal.dimensions.dozenDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionW = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionH ||
              combVal.dimensions.dozenDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionH = true;
            }
            if (
              !combVal.dimensions.dozenWeight ||
              combVal.dimensions.dozenWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenWeight =
                true;
            }
          }
          if (combVal.dimensions.product[3].isChecked) {
            if (
              !combVal.dimensions.piecePrice ||
              combVal.dimensions.piecePrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.piecePrice =
                true;
            }
            if (combVal.dimensions.pieceDiscount === "0") {
              if (
                combVal.dimensions.pieceDiscountPrice &&
                combVal.dimensions.pieceDiscountPrice !== "" &&
                combVal.dimensions.piecePrice &&
                combVal.dimensions.piecePrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.pieceDiscountPrice) >
                  parseInt(combVal.dimensions.piecePrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.pieceDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.pieceDimenisionL ||
              combVal.dimensions.pieceDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionL = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionW ||
              combVal.dimensions.pieceDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionW = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionH ||
              combVal.dimensions.pieceDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionH = true;
            }
            if (
              !combVal.dimensions.pieceWeight ||
              combVal.dimensions.pieceWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.pieceWeight =
                true;
            }
          }
          let result = combinationValidation.some((el: any) => {
            return el === true;
          });
          generalValidationTemp.combinations[index].validation = result;
        });
      }
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkTechnicalDetailsValiadtions = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    if (
      generalDataTemp.defaultTechnicalFields &&
      generalDataTemp.defaultTechnicalFields.length
    ) {
      generalDataTemp.defaultTechnicalFields.map(
        (techVal: any, techIndex: number) => {
          if (
            techVal.type === SingleLineText ||
            techVal.type === MultiLineText
          ) {
            if (
              techVal.answer === undefined ||
              techVal.answer === null ||
              techVal.answer === ""
            ) {
              if (techVal.type === DateSelection) {
                techVal.answer = new Date();
              } else {
                valid.push(true);
                generalDataValidation.defaultTechnicalFields[techIndex][
                  "valid"
                ] = true;
              }
            }
            // form.append("technicalInfo["+techIndex+"][answer]",techVal.answer);
          }
          if (
            techVal.type === MultiSelection ||
            techVal.type === SingleSelection
          ) {
            if (
              techVal.selectedOptions === undefined ||
              techVal.selectedOptions === null ||
              techVal.selectedOptions.length === 0
            ) {
              valid.push(true);
              generalDataValidation.defaultTechnicalFields[techIndex]["valid"] =
                true;
            }
          }
        }
      );
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el: any) => {
      return el === true;
    });
    return validationResult;
  };
  const handlePreviousSelectTab = async (tab: any) => {
    setNavTab(tab.value, generalData, generalDataValidation);
  };
  const handleImage = async (event: any, index: number) => {
    const selectedFiles = event.target.files;
    let temp = { ...generalData };
    if (!selectedFiles) return;
    else {
      let temp2 = JSON.parse(JSON.stringify(temp));
      let generalValidationTemp = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      let imageTemp: any = [];
      for (let i = 0; i < selectedFiles.length; i++) {
        if (fileValidation(selectedFiles?.[i])) {
          await toBase64(selectedFiles?.[i]).then((data) => {
            temp2.combinations[index].dimensions.images.push({
              url: URL.createObjectURL(selectedFiles?.[i]),
              obj: data,
            });
          });
        }
      }
      await setGeneralData(temp2);
      generalValidationTemp.combinations[index].dimensions.images = false;
      await setGeneralDataValidation(generalValidationTemp);
    }
  };
  const toBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleRemoveImage = (index: number, productIndex: number) => {
    let temp = { ...generalData };
    let generalValidationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    let data = temp.combinations[index];
    let updatedImage = data.dimensions.images.filter(
      (e: any, i: number) => i !== productIndex
    );
    if (data.dimensions.imageReader) {
      let updatedImageReader = data.dimensions.imageReader.filter(
        (e: any, i: number) => i !== productIndex
      );
      data.dimensions.imageReader = updatedImageReader;
    }
    if (!updatedImage.length) {
      generalValidationTemp.combinations[index].dimensions.images = true;
    }
    data.dimensions.images = updatedImage;
    setGeneralDataValidation(generalValidationTemp);
    setGeneralData(temp);
  };
  function findCategoryById(categories: any[], id: string): any | undefined {
    for (const category of categories) {
      if (category._id === id) {
        return category;
      }
      if (category.categories && category.categories.length > 0) {
        const result = findCategoryById(category.categories, id);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }
  const handleSubmit = async () => {
    let temp: any = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    temp.combinations.map((combVal: any, index: number) => {
      if (
        combVal.dimensions.product[0].isChecked ||
        combVal.dimensions.product[1].isChecked ||
        combVal.dimensions.product[2].isChecked ||
        combVal.dimensions.product[3].isChecked
      ) {
        if (!combVal.dimensions.images.length) {
          generalValidationTemp.combinations[index].dimensions.images = true;
          valid.push(true);
        }
      }
    });
    setGeneralDataValidation(generalValidationTemp);
    let checked = valid.some((el: any) => {
      return el === true;
    });
    if (!checked) {
      setLoading(true);
      let updatedObject: any = {
        primaryCategory: temp.primaryCategory,
        subCategory: temp.subCategory,
        productTitle: temp.productTitle,
        isDraft: false,
        taxFree: temp.taxFree,
        searchTag:temp.searchTag
      };
      if (temp.country)
        updatedObject = { ...updatedObject, country: temp.country };
      if (temp.groupCategory)
        updatedObject = { ...updatedObject, groupCategory: temp.groupCategory };
      if (temp.brand) updatedObject = { ...updatedObject, brand: temp.brand };
      if (temp.description)
        updatedObject = { ...updatedObject, description: temp.description };
      if (!temp.taxFree)
        updatedObject = { ...updatedObject, productTax: temp.productTax };
      if (
        temp.overrideVariantsTechnicalInfo !== null ||
        temp.overrideVariantsTechnicalInfo !== undefined
      )
        updatedObject = {
          ...updatedObject,
          overrideVariantsTechnicalInfo: temp.overrideVariantsTechnicalInfo,
        };
      if (temp.selectedVariant && temp.selectedVariant.length) {
        updatedObject = {
          ...updatedObject,
          selectedVariant: temp.selectedVariant,
        };
      }
      if (temp.combinations.length) {
        let combinationTemp: any = [];
        temp.combinations.map((combVal: any, combIndex: number) => {
          let innerTemp: any = {
            piecesDozens: combVal.dimensions.piecesDozens,
            cartoonDozens: combVal.dimensions.cartoonDozens,
            cartoonPieces: combVal.dimensions.cartoonPieces,
          };
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            innerTemp = {
              ...innerTemp,
              cartonWithDozens: combVal.dimensions.product[0].isChecked,
              cartonWithPieces: combVal.dimensions.product[1].isChecked,
              cartoonPrice: combVal.dimensions.cartoonPrice,
              cartoonDiscount: combVal.dimensions.cartoonDiscount,
              cartoonDiscountPrice: combVal.dimensions.cartoonDiscountPrice,
              cartoonDimenisionL: combVal.dimensions.cartoonDimenisionL,
              cartoonDimenisionW: combVal.dimensions.cartoonDimenisionW,
              cartoonDimenisionH: combVal.dimensions.cartoonDimenisionH,
              cartoonWeight: combVal.dimensions.cartoonWeight,
              cartoonQuantities: combVal.dimensions.cartoonQuantities,
            };
          }
          if (combVal.dimensions.product[2].isChecked) {
            innerTemp = {
              ...innerTemp,
              dozenChecked: true,
              dozenPrice: combVal.dimensions.dozenPrice,
              dozenDiscount: combVal.dimensions.dozenDiscount,
              dozenDiscountPrice: combVal.dimensions.dozenDiscountPrice,
              dozenDimenisionL: combVal.dimensions.dozenDimenisionL,
              dozenDimenisionW: combVal.dimensions.dozenDimenisionW,
              dozenDimenisionH: combVal.dimensions.dozenDimenisionH,
              dozenWeight: combVal.dimensions.dozenWeight,
              dozenQuantities: combVal.dimensions.dozenQuantities,
            };
          }
          if (combVal.dimensions.product[3].isChecked) {
            innerTemp = {
              ...innerTemp,
              pieceChecked: true,
              piecePrice: combVal.dimensions.piecePrice,
              pieceDiscount: combVal.dimensions.pieceDiscount,
              pieceDiscountPrice: combVal.dimensions.pieceDiscountPrice,
              pieceDimenisionL: combVal.dimensions.pieceDimenisionL,
              pieceDimenisionW: combVal.dimensions.pieceDimenisionW,
              pieceDimenisionH: combVal.dimensions.pieceDimenisionH,
              pieceWeight: combVal.dimensions.pieceWeight,
              pieceQuantities: combVal.dimensions.pieceQuantities,
            };
          }
          let variantsSelected: any = [];
          if (combVal.id) {
            // let selectedVariantsId: any = combVal.id.split('-');
            // let selectedVariantsTitle: any = combVal.title
            //   .split('(')[1]
            //   .replace(')', ' ')
            //   .split(',');
            // selectedVariantsId.map((val: any, index: number) => {
            //   variantsSelected.push({
            //     id: val,
            //     title: selectedVariantsTitle[index],
            //   });
            // });
            let selectedVariantsId: any = combVal.id.split("-");
            const innerText = extractTextWithinParentheses(combVal.title);
            // Split the inner text by ',' to get an array of titles
            const selectedVariantsTitle = innerText.split(",");
            selectedVariantsId.forEach((val: any, index: number) => {
              variantsSelected.push({
                id: val,
                title:
                  selectedVariantsTitle[index % selectedVariantsTitle.length],
              });
            });
          }
          if (Object.keys(innerTemp).length) {
            innerTemp = {
              ...innerTemp,
              images: combVal.dimensions.images,
              imageReader: combVal.dimensions.imageReader,
              selectedCombinations: variantsSelected,
            };
            combinationTemp.push(innerTemp);
          }
        });
        updatedObject = { ...updatedObject, combinations: combinationTemp };
      }
      if (temp.defaultTechnicalFields && temp.defaultTechnicalFields.length) {
        updatedObject = {
          ...updatedObject,
          defaultTechnicalFields: temp.defaultTechnicalFields,
        };
      }
      let apiService = new APICallService(
        product.editProduct,
        productJSON.addProduct({ product: updatedObject }),
        {
          id: state._id,
        },
        "",
        "",
        "",
        MasterProduct,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();

      if (response) {
        window.history.back();
        success(catalogue.updated);
        const {
          clonedRef: oldClonedRef,
          combinations: oldCombinations,
          defaultGroupCategory: oldDefaultGroupCategory,
          defaultSubCategory: oldDefaultSubCategory,
          defaultTechnicalFields: oldDefaultTechnicalFields,
          selectedVariant: oldSelectedVariant,
          variants: oldVariants,
          variantsUsingSeparateInfo: oldVariantsUsingSeparateInfo,
          searchTag: oldSearchTags,
          ...resOldData
        } = initialProductData;
        const {
          clonedRef: newClonedRef,
          combinations: newCombinations,
          defaultGroupCategory: newDefaultGroupCategory,
          defaultSubCategory: newDefaultSubCategory,
          defaultTechnicalFields: newDefaultTechnicalFields,
          selectedVariant: newSelectedVariant,
          variants: newVariants,
          variantsUsingSeparateInfo: newVariantsUsingSeparateInfo,
          searchTag:newSearchTags,
          ...resNewData
        } = generalData;

        resOldData.brand =
          brands.find((item: any) => item?._id === resOldData.brand)?.title ||
          "";
        resNewData.brand =
          brands.find((item: any) => item?._id === resNewData.brand)?.title ||
          "";
        resOldData.country =
          countries.find((item: any) => item?._id === resOldData.country)
            ?.name || "";
        resNewData.country =
          countries.find((item: any) => item?._id === resNewData.country)
            ?.name || "";
        resOldData.primaryCategory =
          categories.find(
            (item: any) => item?._id === resOldData.primaryCategory
          )?.title || "";
        resNewData.primaryCategory =
          categories.find((item: any) => {
            return item?._id === resNewData.primaryCategory;
          })?.title || "";
        resOldData.subCategory = getSubCategoryById(resOldData.subCategory);
        resNewData.subCategory = getSubCategoryById(resNewData.subCategory);
        resOldData.groupCategory = getGroupCategoryId(resOldData.groupCategory);
        resNewData.groupCategory = getGroupCategoryId(resNewData.groupCategory);
        const data = Method.compareComplexObjects(resOldData, resNewData);
        let changes: any = [];

        if (initialProductData?.noneSelected && generalData?.noneSelected) {
          //  changes = compareSingleVariant(oldCombinations, newCombinations);
        } else {
          changes = Method.compareCombination(oldCombinations, newCombinations);
        }
        console.log('ccccccccccc',changes);
        const technicalChanges = compareTechnicalFields(
          oldDefaultTechnicalFields,
          newDefaultTechnicalFields
        );
        let { data: searchTagsChanges, isChanged }: any =
          Method.compareSearchTags(
            oldSearchTags?.options || [],
            newSearchTags?.options || []
          );

        if (
          data.newValues.length ||
          data.oldValues.length ||
          changes.length ||
          technicalChanges.length ||
          isChanged
        ) {
        }
      }
      setLoading(false);
    }
  };
  const combine = ([head, ...[headTail, ...tailTail]]: any): any => {
    if (!headTail) {
      // Generate a unique key for single elements
      let temp = head.map((item: any) => {
        return {
          ...item,
          combinationKey: `${item.title}_${item._id}`,
        };
      });
      return temp;
    }
    const combined = headTail.reduce((acc: any, x: any) => {
      return acc.concat(
        head.map((h: any) => {
          let data = {
            title: `${h.title},${x.title}`,
            _id: `${h._id}-${x._id}`,
            combinationKey: `${h.title}_${h._id}_${x.title}_${x._id}`,
          };
          return data;
        })
      );
    }, []);
    return combine([combined, ...tailTail]);
  };
  const setNavTab = (value: any, data?: any, validations?: any) => {
    let tabTemp = [...tab];
    let currentTab = {};
    switch (value) {
      case 0:
        currentTab = {
          name: "General info",
          content: (
            <General
              onGeneralDataChange={onGeneralDataChange}
              generalData={generalData}
              categories={categories}
              countries={countries}
              variants={variants}
              brands={brands}
              technicalFields={technicalFields}
              validations={validations}
              onValidationChange={onValidationChange}
              onCategoryChanges={() => {
                setIsChanged(true);
              }}
            />
          ),
          value: 0,
        };
        break;
      case 3:
        currentTab = {
          name: "Product images",
          content: (
            <ProductImages
              generalData={data}
              handleImage={(event: any, index: any) => {
                handleImage(event, index);
              }}
              handleRemoveImage={handleRemoveImage}
              validations={validations}
              onGeneralDataChange={onGeneralDataChange}
              onValidationChange={onValidationChange}
              loading={loading}
            />
          ),
          value: 3,
        };
        break;
      case 2:
        currentTab = {
          name: "Technical details",
          content: (
            <TechnicalDetails
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              validations={validations}
              onValidationChange={onValidationChange}
            />
          ),
          value: 2,
        };
        break;
      case 1:
        currentTab = {
          name: "Price & dimensions",
          content: (
            <PriceDimesions
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              validations={validations}
              onValidationChange={onValidationChange}
              priceValidation={priceValidation}
            />
          ),
          value: 1,
        };
        break;
      default:
        break;
    }
    setCurrentTab(currentTab);
    setTab(tabTemp);
  };
  const [currentTab, setCurrentTab] = useState<any>({
    name: "General info",
    content: (
      <General
        onGeneralDataChange={onGeneralDataChange}
        generalData={generalData}
        categories={categories}
        countries={countries}
        variants={variants}
        technicalFields={technicalFields}
        brands={brands}
        validations={generalDataValidation}
        onValidationChange={onValidationChange}
        onCategoryChanges={() => {
          setIsChanged(true);
        }}
      />
    ),
    value: 0,
  });
  useEffect(() => {
    // if (currentTab.value === 0) {
    //   if (
    //     generalData.brand === "" ||
    //     generalData.primaryCategory === "" ||
    //     generalData.subCategory === "" ||
    //     generalData.productTitle === "" ||
    //     generalData.country === "" ||
    //     generalData.description === ""
    //   ) {
    //     setDisabled(true);
    //   } else {
    //     setDisabled(false);
    //   }
    // }
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalData]);
  useEffect(() => {
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalDataValidation]);
  function extractTextWithinParentheses(str: string): string {
    let depth = 0;
    let result = "";
    let withinParentheses = false;
    for (let i = 0; i < str.length; i++) {
      if (str[i] === "(") {
        if (depth > 0) {
          result += "("; // Include '(' if it's inside the innermost parentheses
        }
        depth++;
        withinParentheses = true;
      } else if (str[i] === ")") {
        depth--;
        if (depth === 0) {
          withinParentheses = false;
        }
        if (depth > 0) {
          result += ")"; // Include ')' if it's inside the innermost parentheses
        }
      } else if (withinParentheses) {
        result += str[i];
      }
    }
    return result;
  }

  const getSubCategoryById = (id: any) => {
    if (!id || id.length == 0) return "";
    const subCategories = categories.flatMap((item: any) => item?.categories);
    const temp = subCategories.find((item: any) => item?._id === id);
    return temp?.title || "";
  };

  const getGroupCategoryId = (id: any) => {
    if (!id || id.length == 0) return "";
    const groupCategories = categories
      .flatMap((item: any) => item?.categories)
      .flatMap((item: any) => item?.categories);
    const temp = groupCategories.find((item: any) => item?._id === id);
    return temp?.title || "";
  };

  const compareTechnicalFields = (oldData: any, newData: any) => {
    const changes: any = [];
    newData.forEach((item: any, index: number) => {
      let oldItem = oldData[index];
      if (oldItem) {
        if (JSON.stringify(oldItem) !== JSON.stringify(item)) {
          changes.push(item);
        }
      } else {
        changes.push(item);
      }
    });
    return changes;
  };
  return (
    <>
      <ProductAddedSuccessfully
        show={productAddedmodalShow}
        onHide={() => {
          setProductAddedModalShow(false);
        }}
        modalImage={modalImage}
        onSaveAsDraft={() => {
          navigate("/UProcure/products/master-products");
          setProductAddedModalShow(false);
        }}
      />
      {currentTab.value === 3 ? (
        <ProductGuidelines
          show={productGuidelinesmodalShow}
          onHide={() => setProductGuidelinesModalShow(false)}
        />
      ) : (
        <></>
      )}
      {removedTechnicalDetails.length ? (
        <>
          <Notification
            iconColor="#ffb302"
            text={`${removedTechnicalDetails
              .map((val: any) => val)
              .join(', ')} ${removedTechnicalDetails.length === 1 ? 'is' : 'are'
              }
              removed your from product’s technical details as it’s no longer supported in platform.`}
            bgColor="bg-light-warning"
          />
        </>
      ) : (
        <></>
      )}
      {showVariantModal && (
        <RemoveVariants
          show={showVariantModal}
          onHide={() => {
            setNavTab(0, generalData, generalDataValidation);
            setShowVariantModal(false);
          }}
          generalData={generalData}
          onGeneralDataChange={onGeneralDataChange}
          validation={generalDataValidation}
          onNextTab={(tab: any, data: any, validation: any) => {
            setNavTab(tab, data, validation);
            setShowVariantModal(false);
            setGeneralData(data)
          }}
        />
      )}
      <div className="p-5">
        <Row className="mb-5">
          <Col sm>
            <h1 className="fs-22 fw-bolder">Edit product</h1>
          </Col>
        </Row>
        {!fetchLoader ? (
          <Row>
            <Col lg={12}>
              <div className="border border-r10px px-lg-9 px-6 mb-8">
                <Row className="align-items-center">
                  <Col sm>
                    <div className="d-flex flex-md-row h-lg-70px h-md-60px">
                      <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                        {createTabs()}
                      </ul>
                    </div>
                  </Col>
                  {currentTab.value === 3 ? (
                    <Col sm={"auto"}>
                      <Button
                        variant=""
                        type="button"
                        className="btn btn-flush"
                        onClick={() => setProductGuidelinesModalShow(true)}
                      >
                        <span className="fs-18 fw-600 text-primary">
                          View image guideline
                        </span>
                      </Button>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </div>
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active">
                  <>{currentTab.content}</>
                  <div className="d-flex justify-content-end mt-8">
                    {currentTab.value === 0 ? (
                      <></>
                    ) : loading ? (
                      <></>
                    ) : (
                      <div>
                        <Button
                          type="button"
                          className="uw-btn uw-btn-light uw-btn-lg btn btn-lg btn-light btnPrev btn-active-light-primary"
                          onClick={() => {
                            handlePreviousSelectTab(
                              tab[
                              tab.findIndex(
                                (val: any) => val.value === currentTab.value
                              ) - 1
                              ]
                            );
                          }}
                        // disabled={loading}
                        >
                          Previous
                        </Button>
                      </div>
                    )}
                    <div>
                      <Button
                        type="button"
                        className={clsx(
                          loading ? "uw-btn uw-btn-lg btn btn-lg btnNext" : "uw-btn uw-btn-lg btn btn-lg"
                        )}
                        onClick={() => {
                          currentTab.value !== 3
                            ? handleSelectTab(
                              tab[
                              tab.findIndex(
                                (val: any) => val.value === currentTab.value
                              ) + 1
                              ]
                            )
                            : handleSubmit();
                        }}
                        disabled={loading}
                      >
                        {!loading && (
                          <span className="indicator-label">
                            {currentTab.value === 3 ? "Finish" : "Next"}
                          </span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress fs-16 fw-bold"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoader} />
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default EditProduct;
